import { useSelector } from 'react-redux';
import { GlobalState } from '../../../../../main/store';
export const useActivityGroup = () =>
    useSelector((state: GlobalState) => state.activityGroup);
